<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('queryJob.allocateFlights')"
    :width="$selectByLang('350px', '390px')"
    :close-on-click-modal="false"
  >
    <el-form :label-width="$selectByLang('60px', '100px')" label-position="left" style="margin: 0 10px;">
      <el-form-item :label="$t('SeaExport.Flight')">
        <el-input v-model="form.voyageFlight" />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.BookingProperty')">
        <el-select v-model="form.bookingTerm" :clearable="false" size="mini">
          <el-option
            v-for="(item,index) in BOOKING_TERMS"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="ETD">
        <el-date-picker v-model="form.etd" type="date" value-format="yyyy-MM-dd" clearable style="width: 100%;" />
      </el-form-item>
      <el-form-item :label="$t('queryJob.route')">
        <cargo-user-select
          :method-params="{category:'role',shape:'airline'}"
          :default-value="form.planner||''"
          @change="onPlannerChange"
        />
      </el-form-item>
      <el-form-item :label="$t('Payment.operation')">
        <cargo-user-select
          ref="op"
          :method-params="{category:'role',shape:'aeop',officeId:$store.getters.currentOfficeId>1?$store.getters.currentOfficeId:null}"
          :default-value="form.op||''"
          @change="onOpChange"
        />
      </el-form-item>
      <el-form-item :label="$t('queryJob.Documents')">
        <cargo-user-select
          :method-params="{category:'role',shape:'doc'}"
          :default-value="form.dc||''"
          @change="onDcChange"
        />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button type="primary" @click="clickHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { sleep } from '@/utils/commonUtil'
import { BOOKING_TERMS, SB_BOOKING_TYPE } from '@/class/cargo/model/parameters/BookingTerm'
import { batchUpdate } from '@/api/AirExport/airExportJob'

export default {
  name: 'MixFlightDialog',
  components: { cargoUserSelect },
  props: {
    visible: { type: Boolean, required: true },
    jobs: { type: Array, required: true }
  },
  data() {
    return {
      innerVisible: this.visible,
      form: {
        voyageFlight: '',
        bookingTerm: '',
        op: 0,
        planner: 0,
        dc: 0,
        etd: ''
      }
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.fillForm()
      }
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    this.BOOKING_TERMS = BOOKING_TERMS
  },
  methods: {
    onPlannerChange(obj) {
      this.form.planner = obj.value
    },
    onOpChange(obj) {
      this.form.op = obj.value
    },
    onDcChange(obj) {
      this.form.dc = obj.value
    },
    fillForm() {
      const form = this.form
      form.voyageFlight = this.getSameField('voyageFlight') || ''
      form.etd = this.getSameField('etd', true) || 0
      form.op = this.getSameField('op') || 0
      form.dc = this.getSameField('dc') || 0
      form.planner = this.getSameField('planner') || 0
      form.bookingTerm = SB_BOOKING_TYPE.code
      if (form.op === 0) {
        setTimeout(async() => {
          for (let i = 0; i < 5; ++i) {
            if (this.$refs.op.options.length === 0) {
              await sleep(100)
            } else {
              if (this.$refs.op.options.length === 1) {
                form.op = this.$refs.op.options[0].userId
              }
              break
            }
          }
        }, 100)
      }
    },
    getSameField(field, isDate = false) {
      let value
      for (const job of this.jobs)	{
        if (!value && job[field]) {
          value = job[field]
        } else if (isDate && job[field] && value && job[field] !== value) {
          value = undefined
          break
        } else if (!isDate && value !== job[field]) {
          value = undefined
          break
        }
      }
      return value
    },
    clickHandler() {
      const form = this.form
      console.log(form)
      if (!form.voyageFlight) {
        this.$message.info('请输入航班号.')
        return
      }
      if (!form.etd) {
        this.$message.info('请输入ETD.')
        return
      }
      if (!(form.op > 0)) {
        this.$message.info('请输入操作.')
        return
      }
      if (!(form.planner > 0)) {
        this.$message.info('请输入航线.')
        return
      }
      this.$confirm('确定要调配这【' + this.jobs.length + '】票业务的航班吗?', this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        for (const item of this.jobs) {
          Object.assign(item, form)
        }
        batchUpdate(this.jobs, { selectiveType: 'voyageFlight,op,planner,dc,etd', airSelectiveType: 'bookingTerm' }).then(res => {
          this.$message.success('调配成功!')
          this.$emit('callback')
          this.innerVisible = false
        })
      }).catch()
    }
  }
}
</script>
